import React, { useState, useContext } from "react";
import { IconButton, Tooltip, useTheme } from "@material-ui/core";
import AccountTree from "@material-ui/icons/AccountTree";
import { AuthContext } from "../../context/Auth/AuthContext";
import TriggerFlowModal from "../TriggerFlowModal";
import { i18n } from "../../translate/i18n";

const canTriggerFlowOnTicket = (ticket, user, fromKanban = true) => {
  if (!ticket?.id || !user?.id) return false;
  if (ticket.status === "closed") return false;

  if (fromKanban) {
    return ticket.status === "pending" || ticket.status === "open";
  }

  if (ticket.status !== "open") return false;
  return Number(ticket.userId) === Number(user.id);
};

const KanbanTriggerFlowAction = ({
  ticket,
  className,
  iconStyle,
  stopPropagation = true,
}) => {
  const [open, setOpen] = useState(false);
  const { user } = useContext(AuthContext);
  const theme = useTheme();

  if (!canTriggerFlowOnTicket(ticket, user)) {
    return null;
  }

  const handleClick = (e) => {
    if (stopPropagation) {
      e.stopPropagation();
    }
    setOpen(true);
  };

  return (
    <>
      <Tooltip title={i18n.t("messageInput.tooltip.triggerFlow")} placement="top">
        <IconButton size="small" className={className} onClick={handleClick}>
          <AccountTree
            style={{
              fontSize: 16,
              color:
                theme.palette.type === "light"
                  ? theme.palette.secondary.main
                  : "#EEE",
              ...iconStyle,
            }}
          />
        </IconButton>
      </Tooltip>
      {open && (
        <TriggerFlowModal
          open={open}
          onClose={() => setOpen(false)}
          ticketId={ticket.id}
          ticketStatus={ticket.status}
          fromKanban
        />
      )}
    </>
  );
};

export default KanbanTriggerFlowAction;
